export const MESSAGES = {
  en: {
    'nav.skip': 'Skip to main content',
    'nav.home': 'deChess home',
    'nav.main': 'Main navigation',
    'nav.play': 'Play',
    'nav.leaderboard': 'Leaderboard',
    'nav.account': 'Account & network',
    'nav.blockAll': 'Block all challenges',
    'nav.online': 'Online',
    'nav.connecting': 'Connecting',
    'boot.creating': 'Creating your local identity…',
    'boot.failed': 'Identity initialization failed: {message}',
    'notice.joined': 'Joined {scope}. Sampling a random mesh of recently active peers.',
    'notice.joinedVia': 'Joined {scope} through {peer}.',
    'home.pill': 'Public beta · free · no account required',
    'home.welcome': 'Welcome, {name}',
    'home.title': 'Chess belongs to the players.',
    'home.lede': 'Start a game directly with another browser. No ads, no tracking, no platform standing between you and your opponent.',
    'home.configure': 'Configure my connection',
    'home.copyInvite': 'Copy invite link',
    'home.ready': 'Ready to play peer-to-peer',
    'home.connecting': 'Connecting to the chess network…',
    'home.choose': 'Choose your game',
    'home.what': 'What shall we play?',
    'home.mode': 'Game mode',
    'home.standard': 'Standard',
    'home.variants': 'Variants',
    'home.timeClass': 'Standard time class',
    'home.variantTimeClass': 'Variant time class',
    'home.timeControl': 'Time control',
    'home.rated': 'Proof-backed rated game',
    'home.ratedDetail': 'Runs a background time-weave and creates a dual-signed rating certificate.',
    'home.ratedVariant': 'Creates a dual-signed certificate for this variant’s ladder.',
    'home.ratedUntimed': 'Untimed games stay casual and never join the ladder.',
    'home.variantNote': 'Variant games can be rated. Each variant keeps its own leaderboard and rating ladder per time class.',
    'home.variantGroup': 'Chess variant',
    'home.comingSoon': 'Coming soon',
    'home.startLegend': 'Proposed start time',
    'home.bothConfirm': 'When both players confirm',
    'home.bothConfirmDetail': 'No fixed start time. Clock begins after both are online at the board.',
    'home.startIn': 'Start in',
    'home.startDelay': 'Start delay',
    'home.forfeit': 'Opponent must accept and appear within {minutes} minutes of start or risk forfeit.',
    'home.scheduled': 'Scheduled start',
    'home.scheduledDetail': 'Tournament-style commitment. Missing the start window may be declared a loss.',
    'home.wait': 'Wait for opponent to join',
    'home.waitDetail': 'The challenge closes if nobody accepts and joins before this limit.',
    'home.acceptLadder': 'Accept incoming ladder challenges',
    'home.acceptLadderOn': 'Other players can challenge you from the leaderboard for your selected ladder type.',
    'home.acceptLadderOff': 'You are not accepting direct ladder challenges right now.',
    'home.invite': 'Invite a friend',
    'home.createChallenge': 'Create {label}challenge',
    'home.continueEyebrow': 'Paused matches',
    'home.continueTitle': 'Export, import, continue later',
    'home.continueLede': 'Casual games only — rated ladder matches cannot pause. Import a signed .dechess.json file, or reopen a casual game saved in this browser.',
    'home.importMatch': 'Import match file',
    'home.continueOpenSeat': 'open seat',
    'home.step1': 'Create a challenge',
    'home.step1Detail': 'Choose a clock and receive a private game link.',
    'home.step2': 'Share the link',
    'home.step2Detail': 'Your opponent connects directly through WebRTC.',
    'home.step3': 'Just play',
    'home.step3Detail': 'Every move is signed and saved in both browsers.',
    'home.noRegistration': '♙ No registration',
    'home.noAds': '◇ No advertising',
    'home.p2p': '⌁ Peer-to-peer',
    'home.ratedSuffix': ' · rated',
    'class.bullet': 'bullet',
    'class.blitz': 'blitz',
    'class.rapid': 'rapid',
    'class.classical': 'classical',
    'class.untimed': 'untimed',
    'class.daily': 'daily',
    'classCopy.bullet': 'Fast and fearless',
    'classCopy.blitz': 'The community favorite',
    'classCopy.rapid': 'Room to think',
    'classCopy.classical': 'Tournament length',
    'classCopy.untimed': 'No clock at all',
    'classCopy.daily': 'One move at a time',
    'duration.5m': '5 minutes',
    'duration.10m': '10 minutes',
    'duration.15m': '15 minutes',
    'duration.30m': '30 minutes',
    'duration.1h': '1 hour',
    'duration.3h': '3 hours',
    'lobby.chat': 'Lobby chat',
    'lobby.mainRoom': 'Main Room',
    'lobby.newRoom': 'New room',
    'lobby.expand': 'Expand',
    'lobby.collapse': 'Collapse',
    'lobby.roomName': 'Room name',
    'lobby.createRoom': 'Create',
    'lobby.emptyPlayers': 'No other players online yet.',
    'lobby.emptyMessages': 'No messages yet. Say hello — each send costs a small Sloth proof.',
    'lobby.message': 'Message',
    'lobby.placeholder': 'Message the room…',
    'lobby.placeholderJoin': 'Join the lobby to chat',
    'lobby.send': 'Send',
    'lobby.sending': 'Sending…',
    'lobby.challenge': 'Challenge',
    'lobby.challengeName': 'Challenge {name}',
    'lobby.ratedToggle': 'Rated ✓',
    'lobby.unratedToggle': 'Unrated',
    'lobby.challengeType': 'Challenge type',
    'lobby.incoming': 'Incoming challenge',
    'lobby.challengedYou': '{name} challenged you',
    'lobby.ratedGame': 'Proof-backed ladder game',
    'lobby.casual': 'Casual game — not rated',
    'lobby.openAccept': 'Open accept link',
    'lobby.accept': 'Accept challenge',
    'lobby.decline': 'Decline',
    'lobby.sent': 'Challenge sent',
    'lobby.waiting': 'Waiting for {name} to accept',
    'lobby.keepOpen': '{label} — waiting for them to accept. Open the board in this tab when ready.',
    'lobby.openBoard': 'Open my board',
    'lobby.cancel': 'Cancel',
    'lobby.ratedHintOn': 'Rated: proof-backed ladder game',
    'lobby.ratedHintOff': 'Unrated: casual game, off the ladder',
    'board.community': 'Community ladder',
    'board.title': 'Verified, local, and reproducible.',
    'board.lede': 'Every point is rebuilt in your browser from dual-signed, time-weave-backed result certificates. Standard and variant ladders stay separate.',
    'board.shards': 'certificate shards covered',
    'board.coverage': 'Coverage grows through peers and adaptive archivists.',
    'board.mode': 'Leaderboard mode',
    'board.variant': 'Leaderboard variant',
    'board.timeClass': 'Leaderboard time class',
    'board.period': 'Leaderboard period',
    'board.weekly': 'weekly',
    'board.allTime': 'all-time',
    'board.rank': 'Rank',
    'board.player': 'Player',
    'board.points': 'Points',
    'board.rating': 'Rating',
    'board.wdl': 'W–D–L',
    'board.challengeCol': 'Challenge',
    'board.noCountry': 'No country set',
    'board.challengeFor': 'Challenge for {label}',
    'board.joinToChallenge': 'Join the lobby to challenge',
    'board.empty': 'No verified {label} results in this local shard view yet.',
    'board.emptyHint': 'Rated results only. Unrated games stay off the ladder. Check the matching time class (10+0 is rapid).',
    'medal.gold': 'Gold',
    'medal.silver': 'Silver',
    'medal.bronze': 'Bronze',
    'form.perfect': 'Perfect form',
    'form.points': 'High points',
    'form.winning': 'Winning ledger',
    'game.check': 'Check'
  },
  es: {
    'nav.skip': 'Saltar al contenido',
    'nav.home': 'Inicio de deChess',
    'nav.main': 'Navegación principal',
    'nav.play': 'Jugar',
    'nav.leaderboard': 'Clasificación',
    'nav.account': 'Cuenta y red',
    'nav.blockAll': 'Bloquear todos los desafíos',
    'nav.online': 'En línea',
    'nav.connecting': 'Conectando',
    'boot.creating': 'Creando tu identidad local…',
    'boot.failed': 'No se pudo iniciar la identidad: {message}',
    'notice.joined': 'Entraste a {scope}. Tomando una muestra al azar de pares activos hace poco.',
    'notice.joinedVia': 'Entraste a {scope} a través de {peer}.',
    'home.pill': 'Beta pública · gratis · sin cuenta',
    'home.welcome': 'Hola, {name}',
    'home.title': 'El ajedrez es de los jugadores.',
    'home.lede': 'Empieza una partida directo con otro navegador. Sin anuncios, sin rastreo y sin una plataforma entre tú y tu rival.',
    'home.configure': 'Configurar mi conexión',
    'home.copyInvite': 'Copiar enlace de invitación',
    'home.ready': 'Listo para jugar entre pares',
    'home.connecting': 'Conectando a la red de ajedrez…',
    'home.choose': 'Elige tu partida',
    'home.what': '¿Qué jugamos?',
    'home.mode': 'Modo de juego',
    'home.standard': 'Estándar',
    'home.variants': 'Variantes',
    'home.timeClass': 'Ritmo de juego estándar',
    'home.variantTimeClass': 'Ritmo de la variante',
    'home.timeControl': 'Control de tiempo',
    'home.rated': 'Partida puntuada con prueba',
    'home.ratedDetail': 'Ejecuta un tejido de tiempo en segundo plano y crea un certificado de rating firmado por ambos.',
    'home.ratedVariant': 'Crea un certificado firmado por ambos para la clasificación de esta variante.',
    'home.ratedUntimed': 'Las partidas sin límite son casuales y nunca entran en la clasificación.',
    'home.variantNote': 'Las variantes pueden ser puntuadas. Cada una tiene su propia clasificación y rating por ritmo de juego.',
    'home.variantGroup': 'Variante de ajedrez',
    'home.comingSoon': 'Pronto',
    'home.startLegend': 'Hora de inicio propuesta',
    'home.bothConfirm': 'Cuando ambos confirmen',
    'home.bothConfirmDetail': 'Sin hora fija. El reloj empieza cuando los dos están en el tablero.',
    'home.startIn': 'Empieza en',
    'home.startDelay': 'Demora de inicio',
    'home.forfeit': 'El rival debe aceptar y presentarse dentro de {minutes} minutos del inicio o puede perder por incomparecencia.',
    'home.scheduled': 'Inicio programado',
    'home.scheduledDetail': 'Compromiso de torneo. Faltar a la ventana de inicio puede contarse como derrota.',
    'home.wait': 'Esperar a que el rival entre',
    'home.waitDetail': 'El desafío se cierra si nadie acepta y entra antes de este límite.',
    'home.acceptLadder': 'Aceptar desafíos de la clasificación',
    'home.acceptLadderOn': 'Otros jugadores pueden desafiarte desde la clasificación para el ritmo que elegiste.',
    'home.acceptLadderOff': 'Ahora no estás aceptando desafíos directos de la clasificación.',
    'home.invite': 'Invitar a un amigo',
    'home.createChallenge': 'Crear desafío {label}',
    'home.continueEyebrow': 'Partidas en pausa',
    'home.continueTitle': 'Exportar, importar y continuar después',
    'home.continueLede': 'Solo partidas casuales — las partidas ranking no se pueden pausar. Importa un .dechess.json firmado, o reabre una partida casual guardada en este navegador.',
    'home.importMatch': 'Importar partida',
    'home.continueOpenSeat': 'asiento libre',
    'home.step1': 'Crea un desafío',
    'home.step1Detail': 'Elige un reloj y recibe un enlace privado de partida.',
    'home.step2': 'Comparte el enlace',
    'home.step2Detail': 'Tu rival se conecta directo por WebRTC.',
    'home.step3': 'A jugar',
    'home.step3Detail': 'Cada jugada se firma y se guarda en ambos navegadores.',
    'home.noRegistration': '♙ Sin registro',
    'home.noAds': '◇ Sin publicidad',
    'home.p2p': '⌁ Entre pares',
    'home.ratedSuffix': ' · puntuada',
    'class.bullet': 'bullet',
    'class.blitz': 'blitz',
    'class.rapid': 'rápida',
    'class.classical': 'clásica',
    'class.untimed': 'sin límite',
    'class.daily': 'diaria',
    'classCopy.bullet': 'Rápida y audaz',
    'classCopy.blitz': 'La favorita de la comunidad',
    'classCopy.rapid': 'Tiempo para pensar',
    'classCopy.classical': 'Ritmo de torneo',
    'classCopy.untimed': 'Sin reloj',
    'classCopy.daily': 'Una jugada por vez',
    'duration.5m': '5 minutos',
    'duration.10m': '10 minutos',
    'duration.15m': '15 minutos',
    'duration.30m': '30 minutos',
    'duration.1h': '1 hora',
    'duration.3h': '3 horas',
    'lobby.chat': 'Chat del lobby',
    'lobby.mainRoom': 'Sala principal',
    'lobby.newRoom': 'Nueva sala',
    'lobby.expand': 'Ampliar',
    'lobby.collapse': 'Contraer',
    'lobby.roomName': 'Nombre de la sala',
    'lobby.createRoom': 'Crear',
    'lobby.emptyPlayers': 'Todavía no hay otros jugadores en línea.',
    'lobby.emptyMessages': 'Todavía no hay mensajes. Saluda: cada envío cuesta una pequeña prueba Sloth.',
    'lobby.message': 'Mensaje',
    'lobby.placeholder': 'Escribe en la sala…',
    'lobby.placeholderJoin': 'Entra al lobby para chatear',
    'lobby.send': 'Enviar',
    'lobby.sending': 'Enviando…',
    'lobby.challenge': 'Desafiar',
    'lobby.challengeName': 'Desafiar a {name}',
    'lobby.ratedToggle': 'Puntuada ✓',
    'lobby.unratedToggle': 'Sin puntaje',
    'lobby.challengeType': 'Tipo de desafío',
    'lobby.incoming': 'Desafío entrante',
    'lobby.challengedYou': '{name} te desafió',
    'lobby.ratedGame': 'Partida de clasificación con prueba',
    'lobby.casual': 'Partida casual, sin puntaje',
    'lobby.openAccept': 'Abrir enlace de aceptación',
    'lobby.accept': 'Aceptar desafío',
    'lobby.decline': 'Rechazar',
    'lobby.sent': 'Desafío enviado',
    'lobby.waiting': 'Esperando a que {name} acepte',
    'lobby.keepOpen': '{label} — esperando que acepten. Abrí el tablero en esta pestaña cuando quieras.',
    'lobby.openBoard': 'Abrir mi tablero',
    'lobby.cancel': 'Cancelar',
    'lobby.ratedHintOn': 'Puntuada: partida de clasificación con prueba',
    'lobby.ratedHintOff': 'Sin puntaje: partida casual, fuera de la clasificación',
    'board.community': 'Clasificación de la comunidad',
    'board.title': 'Verificada, local y reproducible.',
    'board.lede': 'Cada punto se reconstruye en tu navegador a partir de certificados de resultado firmados por ambos y respaldados por el tejido de tiempo. Las clasificaciones estándar y de variantes van por separado.',
    'board.shards': 'fragmentos de certificados cubiertos',
    'board.coverage': 'La cobertura crece con los pares y los archivistas que se ofrecen.',
    'board.mode': 'Modo de clasificación',
    'board.variant': 'Variante de la clasificación',
    'board.timeClass': 'Ritmo de la clasificación',
    'board.period': 'Período de la clasificación',
    'board.weekly': 'semanal',
    'board.allTime': 'histórico',
    'board.rank': 'Puesto',
    'board.player': 'Jugador',
    'board.points': 'Puntos',
    'board.rating': 'Rating',
    'board.wdl': 'G–E–P',
    'board.challengeCol': 'Desafío',
    'board.noCountry': 'Sin país',
    'board.challengeFor': 'Desafiar por {label}',
    'board.joinToChallenge': 'Entra al lobby para desafiar',
    'board.empty': 'Todavía no hay resultados verificados de {label} en esta vista local.',
    'board.emptyHint': 'Solo cuentan las partidas puntuadas. Las sin puntaje no entran. Revisa el ritmo correcto (10+0 es rápida).',
    'medal.gold': 'Oro',
    'medal.silver': 'Plata',
    'medal.bronze': 'Bronce',
    'form.perfect': 'Racha perfecta',
    'form.points': 'Muchos puntos',
    'form.winning': 'Balance ganador',
    'game.check': 'Jaque'
  },
  fr: {
    'nav.skip': 'Aller au contenu',
    'nav.home': 'Accueil de deChess',
    'nav.main': 'Navigation principale',
    'nav.play': 'Jouer',
    'nav.leaderboard': 'Classement',
    'nav.account': 'Compte et réseau',
    'nav.blockAll': 'Bloquer tous les défis',
    'nav.online': 'En ligne',
    'nav.connecting': 'Connexion',
    'boot.creating': 'Création de ton identité locale…',
    'boot.failed': 'Échec de l’initialisation de l’identité : {message}',
    'notice.joined': 'Salon {scope} rejoint. Échantillon aléatoire de pairs actifs récemment.',
    'notice.joinedVia': 'Salon {scope} rejoint via {peer}.',
    'home.pill': 'Bêta publique · gratuit · sans compte',
    'home.welcome': 'Bienvenue, {name}',
    'home.title': 'Les échecs appartiennent aux joueurs.',
    'home.lede': 'Commence une partie directement avec un autre navigateur. Sans publicité, sans pistage, sans plateforme entre toi et ton adversaire.',
    'home.configure': 'Configurer ma connexion',
    'home.copyInvite': 'Copier le lien d’invitation',
    'home.ready': 'Prêt à jouer en pair à pair',
    'home.connecting': 'Connexion au réseau d’échecs…',
    'home.choose': 'Choisis ta partie',
    'home.what': 'Que jouons-nous ?',
    'home.mode': 'Mode de jeu',
    'home.standard': 'Standard',
    'home.variants': 'Variantes',
    'home.timeClass': 'Cadence standard',
    'home.variantTimeClass': 'Cadence de la variante',
    'home.timeControl': 'Contrôle du temps',
    'home.rated': 'Partie classée avec preuve',
    'home.ratedDetail': 'Lance un tissage temporel en arrière-plan et crée un certificat de classement signé par les deux joueurs.',
    'home.ratedVariant': 'Crée un certificat signé par les deux joueurs pour le classement de cette variante.',
    'home.ratedUntimed': 'Les parties sans limite restent amicales et n’entrent jamais au classement.',
    'home.variantNote': 'Les variantes peuvent être classées. Chacune a son propre classement et son Elo par cadence.',
    'home.variantGroup': 'Variante d’échecs',
    'home.comingSoon': 'Bientôt',
    'home.startLegend': 'Heure de début proposée',
    'home.bothConfirm': 'Quand les deux confirment',
    'home.bothConfirmDetail': 'Pas d’heure fixe. La pendule démarre lorsque les deux sont au plateau.',
    'home.startIn': 'Commence dans',
    'home.startDelay': 'Délai de début',
    'home.forfeit': 'L’adversaire doit accepter et se présenter dans les {minutes} minutes suivant le début, sous peine de forfait.',
    'home.scheduled': 'Début programmé',
    'home.scheduledDetail': 'Engagement de tournoi. Manquer la fenêtre de début peut compter comme une défaite.',
    'home.wait': 'Attendre que l’adversaire rejoigne',
    'home.waitDetail': 'Le défi se ferme si personne n’accepte et ne rejoint avant cette limite.',
    'home.acceptLadder': 'Accepter les défis du classement',
    'home.acceptLadderOn': 'Les autres joueurs peuvent te défier depuis le classement pour la cadence choisie.',
    'home.acceptLadderOff': 'Tu n’acceptes pas les défis directs du classement pour le moment.',
    'home.invite': 'Inviter un ami',
    'home.createChallenge': 'Créer un défi {label}',
    'home.continueEyebrow': 'Parties en pause',
    'home.continueTitle': 'Exporter, importer, reprendre plus tard',
    'home.continueLede': 'Parties casual uniquement — les parties classées ne se mettent pas en pause. Importez un .dechess.json signé, ou rouvrez une partie casual enregistrée ici.',
    'home.importMatch': 'Importer une partie',
    'home.continueOpenSeat': 'place libre',
    'home.step1': 'Crée un défi',
    'home.step1Detail': 'Choisis une pendule et reçois un lien de partie privé.',
    'home.step2': 'Partage le lien',
    'home.step2Detail': 'Ton adversaire se connecte directement en WebRTC.',
    'home.step3': 'Il ne reste qu’à jouer',
    'home.step3Detail': 'Chaque coup est signé et enregistré dans les deux navigateurs.',
    'home.noRegistration': '♙ Sans inscription',
    'home.noAds': '◇ Sans publicité',
    'home.p2p': '⌁ Pair à pair',
    'home.ratedSuffix': ' · classée',
    'class.bullet': 'bullet',
    'class.blitz': 'blitz',
    'class.rapid': 'rapide',
    'class.classical': 'classique',
    'class.untimed': 'sans limite',
    'class.daily': 'quotidienne',
    'classCopy.bullet': 'Rapide et sans peur',
    'classCopy.blitz': 'La favorite de la communauté',
    'classCopy.rapid': 'Le temps de réfléchir',
    'classCopy.classical': 'Cadence de tournoi',
    'classCopy.untimed': 'Sans pendule',
    'classCopy.daily': 'Un coup à la fois',
    'duration.5m': '5 minutes',
    'duration.10m': '10 minutes',
    'duration.15m': '15 minutes',
    'duration.30m': '30 minutes',
    'duration.1h': '1 heure',
    'duration.3h': '3 heures',
    'lobby.chat': 'Chat du salon',
    'lobby.mainRoom': 'Salon principal',
    'lobby.newRoom': 'Nouveau salon',
    'lobby.expand': 'Développer',
    'lobby.collapse': 'Réduire',
    'lobby.roomName': 'Nom du salon',
    'lobby.createRoom': 'Créer',
    'lobby.emptyPlayers': 'Aucun autre joueur en ligne pour le moment.',
    'lobby.emptyMessages': 'Pas encore de messages. Dis bonjour : chaque envoi coûte une petite preuve Sloth.',
    'lobby.message': 'Message',
    'lobby.placeholder': 'Écrire dans le salon…',
    'lobby.placeholderJoin': 'Rejoins le salon pour discuter',
    'lobby.send': 'Envoyer',
    'lobby.sending': 'Envoi…',
    'lobby.challenge': 'Défier',
    'lobby.challengeName': 'Défier {name}',
    'lobby.ratedToggle': 'Classée ✓',
    'lobby.unratedToggle': 'Non classée',
    'lobby.challengeType': 'Type de défi',
    'lobby.incoming': 'Défi reçu',
    'lobby.challengedYou': '{name} t’a défié',
    'lobby.ratedGame': 'Partie de classement avec preuve',
    'lobby.casual': 'Partie amicale, non classée',
    'lobby.openAccept': 'Ouvrir le lien d’acceptation',
    'lobby.accept': 'Accepter le défi',
    'lobby.decline': 'Refuser',
    'lobby.sent': 'Défi envoyé',
    'lobby.waiting': 'En attente de l’acceptation de {name}',
    'lobby.keepOpen': '{label} — en attente de leur acceptation. Ouvre le plateau dans cet onglet quand tu es prêt.',
    'lobby.openBoard': 'Ouvrir mon échiquier',
    'lobby.cancel': 'Annuler',
    'lobby.ratedHintOn': 'Classée : partie de classement avec preuve',
    'lobby.ratedHintOff': 'Non classée : partie amicale, hors classement',
    'board.community': 'Classement de la communauté',
    'board.title': 'Vérifié, local et reproductible.',
    'board.lede': 'Chaque point est reconstruit dans ton navigateur à partir de certificats de résultat signés par les deux joueurs et appuyés par le tissage temporel. Les classements standard et de variantes restent séparés.',
    'board.shards': 'fragments de certificats couverts',
    'board.coverage': 'La couverture grandit grâce aux pairs et aux archivistes volontaires.',
    'board.mode': 'Mode du classement',
    'board.variant': 'Variante du classement',
    'board.timeClass': 'Cadence du classement',
    'board.period': 'Période du classement',
    'board.weekly': 'hebdomadaire',
    'board.allTime': 'historique',
    'board.rank': 'Rang',
    'board.player': 'Joueur',
    'board.points': 'Points',
    'board.rating': 'Classement',
    'board.wdl': 'G–N–P',
    'board.challengeCol': 'Défi',
    'board.noCountry': 'Pays non défini',
    'board.challengeFor': 'Défier pour {label}',
    'board.joinToChallenge': 'Rejoins le salon pour défier',
    'board.empty': 'Pas encore de résultats vérifiés en {label} dans cette vue locale.',
    'board.emptyHint': 'Seules les parties classées comptent. Les parties non classées sont absentes. Vérifiez la cadence (10+0 = rapide).',
    'medal.gold': 'Or',
    'medal.silver': 'Argent',
    'medal.bronze': 'Bronze',
    'form.perfect': 'Série parfaite',
    'form.points': 'Beaucoup de points',
    'form.winning': 'Bilan gagnant',
    'game.check': 'Échec'
  },
  ja: {
    'nav.skip': '本文へスキップ',
    'nav.home': 'deChess ホーム',
    'nav.main': 'メインナビゲーション',
    'nav.play': '対局',
    'nav.leaderboard': 'ランキング',
    'nav.account': 'アカウントと通信',
    'nav.blockAll': 'すべての挑戦を拒否',
    'nav.online': 'オンライン',
    'nav.connecting': '接続中',
    'boot.creating': 'ローカルの身元を作成しています…',
    'boot.failed': '身元の初期化に失敗しました: {message}',
    'notice.joined': '{scope} に参加しました。最近活動したピアを無作為に選んでいます。',
    'notice.joinedVia': '{peer} 経由で {scope} に参加しました。',
    'home.pill': '公開ベータ · 無料 · アカウント不要',
    'home.welcome': 'ようこそ、{name}',
    'home.title': 'チェスは対局者のものです。',
    'home.lede': '別のブラウザと直接対局を始められます。広告も追跡も、相手との間に立つ運営もありません。',
    'home.configure': '接続を設定',
    'home.copyInvite': '招待リンクをコピー',
    'home.ready': 'ピア同士で対局できます',
    'home.connecting': 'チェスのネットワークに接続しています…',
    'home.choose': '対局を選ぶ',
    'home.what': '何を指しますか？',
    'home.mode': '対局モード',
    'home.standard': 'スタンダード',
    'home.variants': 'バリアント',
    'home.timeClass': 'スタンダードの持時間',
    'home.variantTimeClass': 'バリアントの持時間',
    'home.timeControl': '持時間',
    'home.rated': '証明付きレート対局',
    'home.ratedDetail': 'バックグラウンドで時間の織りを実行し、両者署名のレート証明書を作ります。',
    'home.ratedVariant': 'このバリアントのランキング用に、両者署名の証明書を作ります。',
    'home.ratedUntimed': '持ち時間なしの対局はカジュアルのみで、ランキングには入りません。',
    'home.variantNote': 'バリアントもレート対局にできます。バリアントごとに、持時間別のランキングとレートがあります。',
    'home.variantGroup': 'チェスのバリアント',
    'home.comingSoon': '近日公開',
    'home.startLegend': '開始時刻の提案',
    'home.bothConfirm': '両者が確認したとき',
    'home.bothConfirmDetail': '決まった開始時刻はありません。両者が盤面に着いたあと、時計が動きます。',
    'home.startIn': '開始まで',
    'home.startDelay': '開始までの待ち',
    'home.forfeit': '相手は開始から {minutes} 分以内に承諾して現れないと、不戦敗になることがあります。',
    'home.scheduled': '予定された開始',
    'home.scheduledDetail': '大会形式の約束です。開始の時間帯に現れないと負けになることがあります。',
    'home.wait': '相手の参加を待つ',
    'home.waitDetail': 'この期限までに誰も承諾して参加しなければ、挑戦は閉じます。',
    'home.acceptLadder': 'ランキングからの挑戦を受ける',
    'home.acceptLadderOn': '他の対局者が、選んだ持時間のランキングからあなたに挑戦できます。',
    'home.acceptLadderOff': 'いまはランキングからの直接挑戦を受けていません。',
    'home.invite': '友人を誘う',
    'home.createChallenge': '{label}の挑戦を作る',
    'home.continueEyebrow': '中断した対局',
    'home.continueTitle': '書き出し・読み込み・あとで続ける',
    'home.continueLede': 'カジュアル対局のみ — レーティング対局は一時停止できません。署名済み .dechess.json を読み込むか、このブラウザに保存したカジュアル対局を開き直します。',
    'home.importMatch': '対局ファイルを読み込む',
    'home.continueOpenSeat': '空き席',
    'home.step1': '挑戦を作る',
    'home.step1Detail': '持時間を選び、非公開の対局リンクを受け取ります。',
    'home.step2': 'リンクを共有',
    'home.step2Detail': '相手は WebRTC で直接接続します。',
    'home.step3': 'あとは指すだけ',
    'home.step3Detail': 'すべての指し手は署名され、両方のブラウザに保存されます。',
    'home.noRegistration': '♙ 登録不要',
    'home.noAds': '◇ 広告なし',
    'home.p2p': '⌁ ピア同士',
    'home.ratedSuffix': ' · レート',
    'class.bullet': 'ブレット',
    'class.blitz': 'ブリッツ',
    'class.rapid': 'ラピッド',
    'class.classical': 'クラシカル',
    'class.untimed': '持ち時間なし',
    'class.daily': 'デイリー',
    'classCopy.bullet': '速く、恐れず',
    'classCopy.blitz': 'コミュニティの定番',
    'classCopy.rapid': '考える余白',
    'classCopy.classical': '大会の持時間',
    'classCopy.untimed': '時計なし',
    'classCopy.daily': '一手ずつ',
    'duration.5m': '5分',
    'duration.10m': '10分',
    'duration.15m': '15分',
    'duration.30m': '30分',
    'duration.1h': '1時間',
    'duration.3h': '3時間',
    'lobby.chat': 'ロビーのチャット',
    'lobby.mainRoom': 'メインルーム',
    'lobby.newRoom': '新しいルーム',
    'lobby.expand': '開く',
    'lobby.collapse': '閉じる',
    'lobby.roomName': 'ルーム名',
    'lobby.createRoom': '作成',
    'lobby.emptyPlayers': 'まだ他の対局者はオンラインではありません。',
    'lobby.emptyMessages': 'まだメッセージはありません。あいさつをどうぞ。送信のたびに小さな Sloth 証明が要ります。',
    'lobby.message': 'メッセージ',
    'lobby.placeholder': 'ルームへメッセージ…',
    'lobby.placeholderJoin': 'チャットにはロビーへの参加が必要です',
    'lobby.send': '送信',
    'lobby.sending': '送信中…',
    'lobby.challenge': '挑戦',
    'lobby.challengeName': '{name} に挑戦',
    'lobby.ratedToggle': 'レート ✓',
    'lobby.unratedToggle': '非レート',
    'lobby.challengeType': '挑戦の種類',
    'lobby.incoming': '届いた挑戦',
    'lobby.challengedYou': '{name} が挑戦してきました',
    'lobby.ratedGame': '証明付きのランキング対局',
    'lobby.casual': 'カジュアル対局（非レート）',
    'lobby.openAccept': '承諾リンクを開く',
    'lobby.accept': '挑戦を受ける',
    'lobby.decline': '辞退',
    'lobby.sent': '挑戦を送りました',
    'lobby.waiting': '{name} の承諾を待っています',
    'lobby.keepOpen': '{label} — 相手の承諾待ちです。準備できたらこのタブで盤面を開いてください。',
    'lobby.openBoard': '自分の盤面を開く',
    'lobby.cancel': '取り消す',
    'lobby.ratedHintOn': 'レート: 証明付きのランキング対局',
    'lobby.ratedHintOff': '非レート: ランキング対象外です',
    'board.community': 'コミュニティのランキング',
    'board.title': '検証でき、ローカルで、再現できます。',
    'board.lede': '点数はすべて、両者署名と時間の織りに裏打ちされた結果証明書から、あなたのブラウザで組み直されます。スタンダードとバリアントのランキングは分かれています。',
    'board.shards': '対象の証明書シャード',
    'board.coverage': '対象範囲は、ピアと参加したアーキビストによって広がります。',
    'board.mode': 'ランキングのモード',
    'board.variant': 'ランキングのバリアント',
    'board.timeClass': 'ランキングの持時間',
    'board.period': 'ランキングの期間',
    'board.weekly': '週間',
    'board.allTime': '全期間',
    'board.rank': '順位',
    'board.player': '対局者',
    'board.points': '点数',
    'board.rating': 'レート',
    'board.wdl': '勝–分–敗',
    'board.challengeCol': '挑戦',
    'board.noCountry': '国未設定',
    'board.challengeFor': '{label} で挑戦',
    'board.joinToChallenge': '挑戦するにはロビーに参加してください',
    'board.empty': 'このローカル表示には、まだ検証済みの {label} 結果がありません。',
    'board.emptyHint': 'レート対局のみ表示されます。非レートは入りません。時間帯も確認してください（10+0 はラピッド）。',
    'medal.gold': '金',
    'medal.silver': '銀',
    'medal.bronze': '銅',
    'form.perfect': '全勝',
    'form.points': '高得点',
    'form.winning': '勝ち越し',
    'game.check': '王手'
  }
};

const DURATION_KEYS = {
  '5 minutes': 'duration.5m',
  '10 minutes': 'duration.10m',
  '15 minutes': 'duration.15m',
  '30 minutes': 'duration.30m',
  '1 hour': 'duration.1h',
  '3 hours': 'duration.3h'
};

export function translate(locale, key, vars = {}) {
  const table = MESSAGES[locale] || MESSAGES.en;
  const template = table[key] ?? MESSAGES.en[key] ?? key;
  return template.replace(/\{(\w+)\}/g, (_, name) => (
    vars[name] === undefined || vars[name] === null ? '' : String(vars[name])
  ));
}

export function translateDuration(locale, label) {
  const key = DURATION_KEYS[label];
  return key ? translate(locale, key) : label;
}
